import { render, staticRenderFns } from "./biology.vue?vue&type=template&id=a66485c6&scoped=true&"
import script from "./biology.vue?vue&type=script&lang=js&"
export * from "./biology.vue?vue&type=script&lang=js&"
import style0 from "./biology.vue?vue&type=style&index=0&id=a66485c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66485c6",
  null
  
)

export default component.exports